import { ReactElement } from 'react';

import { AppointmentEncounterMode } from '@dreryk/egabinet-appointment-frontend-api';
import { EncounterMode } from '@dreryk/egabinet-waitlist-frontend-api';

import { StyledFlex, TextView } from '@dreryk/react-components';
import { createSingleInterpolatedTranslationKey, Translate, useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { IncompatiblePreferenceNotification } from './IncompatiblePreferenceNotification';

type EncounterModeTextViewProps = {
   appointmentEncounterMode: AppointmentEncounterMode;
   encounterMode: EncounterMode;
};

export const EncounterModeTextView = (props: EncounterModeTextViewProps): ReactElement => {
   const translate = useTranslate();
   const shouldShowNotification = Boolean(
      props.appointmentEncounterMode && props.appointmentEncounterMode !== props.encounterMode
   );

   return (
      <TextView testId={'encounterMode'} label={translationKeys.encounterMode}>
         <StyledFlex direction={'column'} gap={'8px'}>
            <Translate>{translationKeys.encounterModeMap[props.appointmentEncounterMode]}</Translate>
            {shouldShowNotification ? (
               <IncompatiblePreferenceNotification
                  testId={'encounterModePreference'}
                  label={createSingleInterpolatedTranslationKey(
                     translationKeys.preference,
                     'label',
                     translate(translationKeys.encounterModeMap[props.encounterMode])
                  )}
               />
            ) : null}
         </StyledFlex>
      </TextView>
   );
};
